import { inject, Injectable } from '@angular/core'
import { VersionHttpService } from '../data-access/http/version-http.service'
import { Observable } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class CoreDomainService {
  private readonly versionHttpService = inject(VersionHttpService)

  getVersionBackend(): Observable<string> {
    return this.versionHttpService.getVersionBackend()
  }
}
